import reducers from './reducers';
import * as practiceActions from './actions';
import * as types from './types';

export { default as selectors } from './selectors';
export { practiceActions, types };

export default reducers;
